import FaqItem from "./FaqItem";

(() => {
  const faqItems = [
    ...Array.from(document.querySelectorAll<HTMLElement>(".faq__item")),
  ];

  faqItems.forEach((faqItem: HTMLElement) => {
    const faq = new FaqItem(
      faqItem,
      ".faq__title-wrapper",
      ".faq__content",
      "is-open",
      "is-closed"
    );

    faq.init();
  });
})();
